import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';

import { getTopDestinations, ITopBookingsState } from '@store/slices';
import { ILoginState } from '@share/store/slices';
import { getNormalizedRoomsResponse, RootState, UrlUtils } from '@share/utils';
import { CarouselSlider } from '@components';

import { HotelSearchArgs, ITopBookings } from '@common-types';
import DestinationCard from './destination-card';

import './style.scss';

interface IMapStateToProps {
  topBookingsStore: ITopBookingsState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  getTopDestinations: (account: any) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps { }

function PopularDestinationsComponent(props: IProps) {

  useEffect(() => {
    props.getTopDestinations(props.loginStore.account);
  }, [])

  const searchHandler: HotelSearchArgs = (selectedLocation, startDate, endDate, rooms, hotelCode) => {
  };

  const { topDestinations, loading } = props.topBookingsStore;

  const destination: ITopBookings = topDestinations;
  const slidesToShow = (!destination?.items || destination?.items?.length >= 5) ? 5 : destination.items.length;

  if (destination && !loading) {
    return (
      <section>
        <div className="container popular-destinations">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-0">Popular Destinations</h2>
            </div>
          </div>
          <div className="row g-4 g-md-5">

            <CarouselSlider lazyLoad="progressive" slidesToShow={slidesToShow}>
              {destination.items?.map((item, index) => (
                <div key={index} className="popular-destinations__img" onClick={(e) => { e.preventDefault(), searchHandler(item.location, destination?.checkIn, destination?.checkOut, destination?.rooms, item?.location?.code) }}>
                  <DestinationCard key={index} {...item} />
                </div>
              ))}
            </CarouselSlider>

          </div>
        </div>
      </section>
    );
  }

  return null;
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    topBookingsStore: state.topBookingsStore,
    loginStore: state.loginStore
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getTopDestinations
};

const PopularDestinations = connect(mapStateToProps, mapDispatchToProps)(withRouter(PopularDestinationsComponent));
export { PopularDestinations };